<template>

  <!-- Вызовы -->
  <v-container fluid>
    <v-expansion-panels v-model="expansion" hover>
      <!-- Фильтры -->
      <v-expansion-panel class="mb-2">
        <v-expansion-panel-header>
          Вызовы
          <span v-if="expansion != 0" class="ml-6">

            <v-tooltip bottom max-width="400">
              <template #activator="{ on }">
                <v-chip
                  color="success"
                  label
                  outlined
                  v-on="on"
                >Временной интервал</v-chip>
              </template>
              <span>
                С: {{ formatDate(filters.period.start) }} <br>
                По: {{ formatDate(filters.period.end) }}
              </span>
            </v-tooltip>

          </span>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <v-form ref="form">
            <ReportFilters
              v-model="filters"
              feed-btn
              with-excel
              @load-report="loadReportClean"
              @load-by-get-params="loadByGetParams"
              @show-feed="showFeed"
            />
          </v-form>

          <v-progress-linear
            v-if="loading"
            indeterminate
            color="green"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- Общая статистика -->
      <v-expansion-panel
        :disabled="statisticLoading && !Object.keys(statistic).length && !statisticPending.length && !(statisticBadges && statisticBadges.length)"
        class="mb-2"
      >
        <v-expansion-panel-header>
          <v-row v-if="'accepted_calls_count' in statistic">
            <!-- Подсказка -->
            <v-col cols="auto">
              <v-tooltip right max-width="400">
                <template #activator="{ on }">
                  <v-icon v-on="on" size="lg" color="info">mdi-information-slab-symbol</v-icon>
                </template>

                <div class="text-body-2">
                  <p class="mb-1">Все данные зависят от выбора селектора</p>
                  <p class="mb-1">Пример: Если вы выбрали в селекторе - "Только принятые", то пропущенных в выдаче будет "0", хотя на самом деле для данного промежутка времени пропущенные есть, но они не отображаются.</p>
                  <p class="mb-1">При воборе <b>одного</b> проекта в селекторе выше, показывается кол-во минут в соответствии с текущей тарификацией у данного проекта.</p>
                  <p class="mb-1">Если выбрано несколько проектов, то процент пропущенных не будет показаны.</p>
                </div>
              </v-tooltip>
            </v-col>

            <v-col>
              <v-badge
                v-if="'total_calls_count' in statistic"
                bordered
                color="success"
                overlap
                class="mr-7"
              >
                <template #badge>
                  <span>{{ statistic.total_calls_count }}</span>
                </template>

                <v-tooltip bottom max-width="400">
                  <template #activator="{ on }">
                    <v-chip
                      color="success"
                      label
                      outlined
                      v-on="on"
                    >Всего</v-chip>
                  </template>
                  <span>Количество вызовов в текущей выдаче</span>
                </v-tooltip>
              </v-badge>

              <v-badge
                v-if="'accepted_calls_count' in statistic"
                bordered
                color="success"
                overlap
                class="mr-7"
              >
                <template #badge>
                  <span>{{ statistic.accepted_calls_count }}</span>
                </template>

                <v-tooltip bottom max-width="400">
                  <template #activator="{ on }">
                    <v-chip
                      color="success"
                      label
                      outlined
                      v-on="on"
                    >Принятых</v-chip>
                  </template>
                  <span>Количество принятых операторами вызовов в текущей выдаче</span>
                </v-tooltip>
              </v-badge>

              <v-badge
                v-if="'missed_calls_count' in statistic"
                bordered
                color="success"
                overlap
                class="mr-7"
              >
                <template #badge>
                  <span>{{ statistic.missed_calls_count }}</span>
                </template>

                <v-tooltip bottom max-width="400">
                  <template #activator="{ on }">
                    <v-chip
                      color="success"
                      label
                      outlined
                      v-on="on"
                    >Пропущенных</v-chip>
                  </template>
                  <span>Количество пропущенных вызовов в текущей выдаче</span>
                </v-tooltip>
              </v-badge>
            </v-col>
          </v-row>
          <span v-else>Общая статистика</span>
          <v-progress-linear
            v-if="statisticLoading"
            indeterminate
            color="green"
            style="position: absolute;bottom: 2px;left: 0;"
          />
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <v-row>
            <!-- Общая статистика -->
            <v-col v-if="'general_statistic' in statistic && statistic.general_statistic.length" cols="12" lg="4" sm="6">
              <h4 class="mb-2">Общая статистика</h4>

              <v-simple-table dense>
                <tbody>
                  <tr
                    v-for="item in statistic.general_statistic"
                    :key="'general-statistic' + item.label"
                  >
                    <th style="user-select: revert;">
                      <v-tooltip v-if="item.description" bottom max-width="400">
                        <template #activator="{ on }">
                          <span v-on="on">{{ item.label }}</span>
                        </template>
                        <span v-text="item.description"></span>
                      </v-tooltip>
                      <span v-else>{{ item.label }}</span>
                    </th>
                    <td>{{ item.value }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
            <v-col v-else-if="isStatisticPending('general')" cols="12" lg="4" sm="6">
              <h4 class="mb-2">Общая статистика</h4>
              <v-skeleton-loader :type="STATISTIC_SKELETON" />
            </v-col>

            <!-- Статистика по входящим / исходящим -->
            <v-col v-if="'incomig_statistic' in statistic && statistic.incomig_statistic.length" cols="12" lg="4" sm="6">
              <h4 class="mb-2">Статистика по входящим</h4>

              <v-simple-table dense>
                <tbody>
                  <tr
                    v-for="item in statistic.incomig_statistic"
                    :key="'incomig-statistic' + item.label"
                  >
                    <th style="user-select: revert;">
                      <v-tooltip v-if="item.description" bottom max-width="400">
                        <template #activator="{ on }">
                          <span v-on="on">{{ item.label }}</span>
                        </template>
                        <span v-text="item.description"></span>
                      </v-tooltip>
                      <span v-else>{{ item.label }}</span>
                    </th>
                    <td>{{ item.value }}</td>
                  </tr>
                </tbody>
              </v-simple-table>

              <div v-if="statistic.outbound_statistic && statistic.outbound_statistic.length" class="mt-6">
                <h4 class="mb-2">Статистика по исходящим кампаниям</h4>

                <v-simple-table dense>
                  <tbody>
                    <tr
                      v-for="item in statistic.outbound_statistic"
                      :key="'outbound-statistic' + item.label"
                    >
                      <th style="user-select: revert;">
                        <v-tooltip v-if="item.description" bottom max-width="400">
                          <template #activator="{ on }">
                            <span v-on="on">{{ item.label }}</span>
                          </template>
                          <span v-text="item.description"></span>
                        </v-tooltip>
                        <span v-else>{{ item.label }}</span>
                      </th>
                      <td>{{ item.value }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </div>
              <div v-else-if="isStatisticPending('outbound')" class="mt-6">
                <h4 class="mb-2">Статистика по исходящим кампаниям</h4>
                <v-skeleton-loader :type="STATISTIC_SKELETON" />
              </div>
            </v-col>
            <v-col v-else-if="isStatisticPending('incoming')" cols="12" lg="4" sm="6">
              <h4 class="mb-2">Статистика по входящим</h4>
              <v-skeleton-loader :type="STATISTIC_SKELETON" />
            </v-col>

            <v-col v-if="'repeat_dials_statistic' in statistic && statistic.repeat_dials_statistic.length" cols="12" lg="4" sm="6">
              <h4 class="mb-2">Повторные номера</h4>

              <v-text-field
                v-model="repeatDialsPhoneSearch"
                class="mb-2"
                dense
                clearable
                hide-details
                label="Поиск по номеру"
                prepend-inner-icon="mdi-magnify"
                single-line
              />

              <div
                v-if="(repeatDialsPhoneSearch || '').trim() && !repeatDialsFiltered.length"
                class="text-body-2 grey--text"
              >
                Нет совпадений
              </div>

              <v-simple-table v-else dense>
                <tbody>
                  <tr
                    v-for="(item, index) in repeatDialsDisplayed"
                    :key="`repeat-call-${item.client_phone}-${index}`"
                  >
                    <th style="user-select: revert;">{{ item.client_phone }}</th>
                    <td>{{ item.count }}</td>
                  </tr>
                </tbody>
              </v-simple-table>

              <v-btn
                v-if="repeatDialsCanToggleExpand"
                class="mt-2 px-0"
                text
                small
                @click="repeatDialsExpanded = !repeatDialsExpanded"
              >
                {{ repeatDialsExpanded ? 'Свернуть' : 'Раскрыть' }}
              </v-btn>
            </v-col>
            <v-col v-else-if="isStatisticPending('repeat-dials')" cols="12" lg="4" sm="6">
              <h4 class="mb-2">Повторные номера</h4>
              <v-skeleton-loader :type="STATISTIC_SKELETON" />
            </v-col>

            <!-- Эмоции -->
            <!-- При нескольких проектах API отдаёт statistic_emotions пустым массивом — блок не показываем -->
            <v-col v-if="statistic.statistic_emotions && statistic.statistic_emotions.client" cols="12" lg="4" sm="6">
              <div>
                <h4 class="mb-2">Эмоции</h4>

                <v-btn-toggle
                  v-model="emoticonMode"
                  mandatory
                  rounded
                  dense
                >
                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <v-btn v-on="on">
                        <v-icon>mdi-face-man</v-icon>
                      </v-btn>
                    </template>
                    <span>Абонент</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <v-btn v-on="on">
                        <v-icon>mdi-face-agent</v-icon>
                      </v-btn>
                    </template>
                    <span>Оператор</span>
                  </v-tooltip>
                </v-btn-toggle>

                <v-simple-table dense>
                  <tbody>
                    <tr
                      v-for="item in statistic.statistic_emotions[emoticonMode === 0 ? 'client' : 'agent'].statistic"
                      :key="'emoticon' + item.type"
                    >
                      <th style="user-select: revert;width: min-content;">
                        <v-tooltip bottom max-width="400">
                          <template #activator="{ on }">
                            <v-btn v-on="on" icon @click="filterByEmotion(item.type, emoticonMode === 0 ? 'client' : 'agent')">
                              <v-icon :color="getEmoColor(item.type)">{{ getEmoIcon(item.type) }}</v-icon>
                            </v-btn>
                          </template>
                          <span v-text="item.label"></span>
                        </v-tooltip>
                      </th>

                      <td style="width: 100%;">
                        <v-progress-linear
                          :value="item.percentage"
                          color="info"
                          height="20"
                        >{{ item.percentage }}%</v-progress-linear>
                      </td>

                      <td>{{ item.value }}</td>
                    </tr>

                    <tr>
                      <td></td>
                      <td></td>
                      <td>{{ emoticonMode === 0 ? statistic.statistic_emotions.client.sum_emotion_client : statistic.statistic_emotions.agent.sum_emotion_agent }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>

                <v-divider class="my-6" />
              </div>
            </v-col>
            <v-col v-else-if="isStatisticPending('emotions')" cols="12" lg="4" sm="6">
              <h4 class="mb-2">Эмоции</h4>
              <v-skeleton-loader :type="STATISTIC_SKELETON" />
            </v-col>

            <!-- Статистика по источникам -->
            <v-col v-if="'statistics_start_exten' in statistic && statistic.statistics_start_exten.length" cols="12" lg="4" sm="6">
              <h4 class="mb-2">Статистика по источникам</h4>

              <v-simple-table dense>
                <thead>
                  <tr>
                    <th>Источник</th>
                    <th>Кол-во вызовов</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="item in statistic.statistics_start_exten"
                    :key="item.label"
                  >
                    <td>{{ item.label }}</td>
                    <td>{{ item.value }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
            <v-col v-else-if="isStatisticPending('start-exten')" cols="12" lg="4" sm="6">
              <h4 class="mb-2">Статистика по источникам</h4>
              <v-skeleton-loader :type="STATISTIC_SKELETON" />
            </v-col>

            <!-- Статистика по callback-интеграциям -->
            <v-col v-if="integrationCallbacks.length" cols="12" lg="4" sm="6">
              <h4 class="mb-2">Статистика по callback-интеграциям</h4>

              <v-simple-table
                v-for="(queue, index) in integrationCallbacks"
                :key="'integration-callbacks-' + queue.queue"
                :class="{ 'mt-4': index > 0 }"
                dense
              >
                <tbody>
                  <tr>
                    <th style="user-select: revert;">Очередь</th>
                    <td>{{ queue.queue }}</td>
                  </tr>
                  <tr v-if="queue.queue_name">
                    <th style="user-select: revert;">Название</th>
                    <td>{{ queue.queue_name }}</td>
                  </tr>
                  <tr
                    v-for="item in queue.statistic || []"
                    :key="'integration-callbacks-' + queue.queue + item.label"
                  >
                    <th style="user-select: revert;">
                      <v-tooltip v-if="item.description" bottom max-width="400">
                        <template #activator="{ on }">
                          <span v-on="on">{{ item.label }}</span>
                        </template>
                        <span v-text="item.description"></span>
                      </v-tooltip>
                      <span v-else>{{ item.label }}</span>
                    </th>
                    <td>{{ item.value }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
            <v-col v-else-if="isStatisticPending('integration-callbacks')" cols="12" lg="4" sm="6">
              <h4 class="mb-2">Статистика по callback-интеграциям</h4>
              <v-skeleton-loader :type="STATISTIC_SKELETON" />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- Отчёт (таблица) -->
      <v-expansion-panel class="mb-2">
        <v-expansion-panel-header>
          Отчёт
        </v-expansion-panel-header>

        <v-expansion-panel-content class="expansion-zero-padding">
          <!-- Пагинация и переключалка над таблицей -->
          <v-row class="ml-10" v-if="callsLoading === false && report.items.length > 0">
            <v-col cols="auto">
              <v-btn-toggle
                v-model="tableMode"
                mandatory
                rounded
                dense
              >
                <v-tooltip bottom>
                  <template #activator="{ on }">
                    <v-btn v-on="on">
                      <v-icon>mdi-comment-text-multiple</v-icon>
                    </v-btn>
                  </template>
                  <span>Статистические данные</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template #activator="{ on }">
                    <v-btn v-on="on">
                      <v-icon>mdi-blur</v-icon>
                    </v-btn>
                  </template>
                  <span>Анализ вызовов</span>
                </v-tooltip>
              </v-btn-toggle>
            </v-col>
            <v-col cols="4">
              <v-pagination
                v-model="meta.current_page"
                :total-visible="paginationTotalVisible"
                :length="meta.last_page"
                @input="pageChange"
              />
            </v-col>
          </v-row>

          <v-data-table
            :headers="report.headers[tableMode]"
            :items="report.items"
            :items-per-page="report.items.length"
            :loading="loading"
            item-key="uid"
            loading-text="Загрузка..."
            no-data-text="Ничего не найдено"
            hide-default-footer
            :expanded.sync="expanded"
            :item-class="rowColor"
            dense
          >
            <!-- Раскрывашка -->
            <template #[`expanded-item`]="{ item, headers }">
              <td v-if="item.complaint !== null" :colspan="headers.length" class="py-5 px-12">

                <h4>Отзыв №{{ item.complaint.id }}</h4>

                <table>
                  <tbody>
                    <tr>
                      <td>Заказчик:</td>
                      <td>{{ item.complaint.project }}</td>
                    </tr>
                    <tr>
                      <td>Тип отзыва:</td>
                      <td>{{ item.complaint.type }}</td>
                    </tr>
                    <tr>
                      <td>КЛН:</td>
                      <td>{{ item.complaint.kln }}</td>
                    </tr>
                    <tr>
                      <td>Критерии:</td>
                      <td>{{ item.complaint.creterials }}</td>
                    </tr>
                    <tr>
                      <td>Комментарий:</td>
                      <td>{{ item.complaint.comment }}</td>
                    </tr>
                    <tr>
                      <td>Автор:</td>
                      <td>{{ item.complaint.created_by }}</td>
                    </tr>
                    <tr>
                      <td>Дата:</td>
                      <td>{{ item.complaint.created_at }}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </template>

            <!-- Хедер оценка -->
            <template #[`header.ivr_grade`]="{ header }">
              <v-tooltip bottom max-width="400">
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{ header.text }}</span>
                </template>

                <span>Оценка (Post IVR оценка оператора)</span>
              </v-tooltip>
            </template>

            <!-- Хедер темы -->
            <template #[`header.subject`]="{ header }">
              <v-tooltip bottom max-width="400">
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{ header.text }}</span>
                </template>

                <span>Тема (Главное поле карточки)</span>
              </v-tooltip>
            </template>

            <!-- Хедер ОТЭ -->
            <template #[`header.analysis_ai_grade`]="{ header }">
              <v-tooltip bottom max-width="400">
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{ header.text }}</span>
                </template>

                <span>ОТЭ (Оценка Телефонного Этикета)</span>
              </v-tooltip>
            </template>

            <!-- Дата -->
            <template #[`item.date`]="{ item }">
              {{ utils.formattingStringWithTime(item.date) }}
            </template>

            <!-- Анализ -->
            <template #[`item.voicer[status]`]="{ item }">
              <v-tooltip bottom v-if="item.status" max-width="400">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" v-if="item.analysis_ai">mdi-blur</v-icon>
                  <v-icon v-else-if="item.voicer">mdi-comment-text-multiple</v-icon>
                </template>

                <span v-if="item.analysis_ai">   <!-- сама всплывающая подсказка -->
                  {{ item.analysis_ai }}
                </span>
              </v-tooltip>
            </template>

            <!-- Наличие карточки звонка -->
            <template #[`item.has_callcard`]="{ item }">
              <v-tooltip bottom v-if="item.has_callcard">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="success">mdi-form-select</v-icon>
                </template>
                <span>Есть карточка по звонку</span>
              </v-tooltip>
            </template>

            <!-- Маркеры абонентов -->
            <template #[`item.voicer[markers][1][dictionary_name]`]="{ item }">
              <p v-if="item.voicer">
                <span v-for="(item1, index) in item.voicer['markers']" v-bind:key="index">
                  <span v-if="item1.for==2">
                    <v-chip label :color="item1.color">
                      {{ item1.dictionary_name }} X {{ item1.words.length }}
                    </v-chip>
                  </span>
                </span>
              </p>
            </template>

            <!-- Маркеры операторов -->
            <template #[`item.voicer[markers][0][dictionary_name]`]="{ item }">
              <p v-if="item.voicer">
                <span v-for="(item1, index) in item.voicer['markers']" v-bind:key="index">
                  <span v-if="item1.for!==2">
                    <v-chip label :color="item1.color">
                      {{ item1.dictionary_name }} X {{ item1.words.length }}
                    </v-chip>
                  </span>
                </span>
              </p>
            </template>

            <!-- Статус -->
            <template #[`item.status`]="{ item }">
              <v-tooltip bottom v-if="item.status">
                <template v-slot:activator="{ on }">
                  <span v-on="on"><!-- то что показано изначально-->
                    <v-icon dense align="left" v-if="item.status === 'Завершен агентом'">mdi-account-remove</v-icon>
                    <v-icon small align="right" v-if="item.status === 'Завершен агентом'">mdi-account-outline</v-icon>

                    <v-icon dense align="left" v-if="item.status === 'Завершен клиентом'">mdi-account-outline</v-icon>
                    <v-icon small align="right" v-if="item.status === 'Завершен клиентом'">mdi-account-remove</v-icon>
                  </span>
                </template>
                <span>   <!-- сама всплывающая подсказка -->
                  <span style="color: #ffffff" v-if="item.transfer"> Переведен на: {{ item.transfer }}</span>
                  <!-- uid стоит чтоб было видно что оно работает, там потом нужен transfer -->
                  <br v-if="item.transfer">
                  <span style="color: #ffffff" v-if="item.status === 'Завершен клиентом'">Завершен клиентом</span>
                  <span style="color: #ffffff" v-if="item.status === 'Завершен агентом'">Завершен агентом</span>
                </span>
              </v-tooltip>
              <span v-else>{{ item }}</span>
            </template>

            <!-- Соответствие скрипту -->
            <template #[`item.script_compliance`]="{ item }">
              <v-tooltip bottom v-if="item.parameters.script_compliance" max-width="400">
                <template v-slot:activator="{ on }">
                  <v-chip
                    v-on="on"
                    small
                    dark
                  >
                    {{ item.parameters.script_compliance }}%
                  </v-chip>
                </template>

                <span>
                  Соответствие скрипту: {{ item.parameters.script_compliance }}%
                </span>
              </v-tooltip>
            </template>

            <!-- Настроения -->
            <template #[`item.emotions`]="{ item }">
              <div style="width: max-content;">
                <!-- Настроение клиента -->
                <v-tooltip bottom v-if="item.parameters.emotion_client" max-width="400">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      target="_blank"
                      :color="getEmoColor(item.parameters.emotion_client)"
                      style="font-size: 30px"
                      :href="getEmoteUrl(item.parameters.emotion_client, 'client')"
                    ><v-icon size="30px">{{ getEmoIcon(item.parameters.emotion_client, 'client') }}</v-icon></v-btn>
                  </template>
                  <span>
                    Настроение клиента: {{ item.parameters.emotion_client }}
                  </span>
                </v-tooltip>
                <!-- Настроение агента -->
                <v-tooltip bottom v-if="item.parameters.emotion_agent" max-width="400">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      target="_blank"
                      :color="getEmoColor(item.parameters.emotion_agent)"
                      style="font-size: 30px"
                      :href="getEmoteUrl(item.parameters.emotion_agent, 'agent')"
                    ><v-icon size="30px">{{ getEmoIcon(item.parameters.emotion_agent, 'agent') }}</v-icon></v-btn>
                  </template>
                  <span>
                    Настроение оператора: {{ item.parameters.emotion_agent }}
                  </span>
                </v-tooltip>
              </div>
            </template>

            <!-- КЛН -->
            <template #[`item.kln`]="{ item }">
              <v-chip
                  v-if="item.kln"
                  small
                  color="success"
                  dark
                  @click="changeExpand(item)"
              >
                {{ item.kln }}
              </v-chip>
            </template>

            <!-- Проверен -->
            <template #[`item.meta`]="{ item }">
              <v-icon v-if="item.meta">mdi-check</v-icon>
            </template>

            <!-- Сброшен -->
            <template #[`item.has_dropped`]="{ item }">
              <span v-if="item.has_dropped">Да</span>
              <span v-else>Нет</span>
            </template>

            <!-- Просмотр -->
            <template #[`item.actions`]="{ item }">
              <v-btn icon @click="viewItem(item)">
                <v-icon dense>mdi-eye</v-icon>
              </v-btn>

              <v-tooltip bottom>
                <template #activator="{ on }">
                  <v-btn v-on="on" icon :href="callUrl(item.uid)" target="_blank">
                    <v-icon>mdi-open-in-new</v-icon>
                  </v-btn>
                </template>
                <span>Открыть звонок в новой вкладке</span>
              </v-tooltip>
            </template>

          </v-data-table>

          <!-- Пагинация под таблицей -->
          <v-row
            v-if="perPage >= 25 && report.items.length > 0"
            class="ml-10 mt-2"
          >
            <v-col cols="4">
              <v-pagination
                v-model="meta.current_page"
                :total-visible="paginationTotalVisible"
                :length="meta.last_page"
                @input="pageChange"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

    </v-expansion-panels>



    <!-- Просмотр звонка модалка -->
    <dialog-view
      v-if="dialogView"
      v-model="dialogView"
      fullscreen
      title="Просмотр информации о вызове"
    >
      <CallInfo :uid="dialogViewUid" />
    </dialog-view>

    <!-- Лента звонков модалка -->
    <Calls-Feed v-model="callsFeedModal" :filters="filters" />


  </v-container>

</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import moment from 'moment'
import ReportFilters from '~/components/pages/stat/elements/ReportFilters.vue'
import CallsFeed from '~/components/partials/Call/CallsFeed.vue'


export default {
  name: 'SpeechAnalysisReport',
  props: ['username'],
  components: {
    ReportFilters,
    CallsFeed,
  },
  data() {
    return {
      expansion: 0, // 0 - фильтры; 1 - общая статистика; 2 - отчет
      tableMode: 0,
      filters: {},

      expanded: [],
      query: {},
      wiretapping_rate: '',
      date: {},

      report: {
        headers: [
          [
            {
              sortable: false
            },
            {
              text: 'Дата',
              value: 'date',
              sortable: false,
              caption: '"Да": Если % прослушки оператора ниже целевого  процента прослушки по проекту или КЛН оператора ниже 90%.',
            },
            {
              text: 'Оператор',
              value: 'agent',
              sortable: false,
            },
            {
              text: 'Очередь',
              value: 'queue',
              sortable: false,
            },
            {
              text: 'Абонент',
              value: 'client',
              sortable: false,
            },
            {
              text: 'Номер назначения',
              value: 'start_exten',
              sortable: false,
            },
            {
              text: '',
              value: 'voicer[status]',
              sortable: false,
            },
            {
              text: 'Статус',
              value: 'status',
              sortable: false,
            },
            {
              text: 'Ожидание',
              value: 'wait',
              sortable: false,
              align: 'center',
            },
            {
              text: 'Длит.',
              value: 'duration',
              sortable: false,
              align: 'center',
            },
            {
              text: 'Карточка',
              value: 'has_callcard',
              sortable: false,
              align: 'center',
            },
            {
              text: 'Клн',
              value: 'kln',
              sortable: false,
              align: 'center',
            },
            {
              text: 'Проверен',
              value: 'meta',
              sortable: false,
              align: 'center',
            },
            {
              text: 'Сброшен',
              value: 'has_dropped',
              sortable: false,
              align: 'center',
            },
            {
              text: 'Оценка',
              value: 'ivr_grade',
              sortable: false,
              align: 'center',
            },
            {
              text: 'Тема',
              value: 'subject',
              sortable: false,
              align: 'center',
            },
            {
              text: 'Просмотр',
              value: 'actions',
              sortable: false
            },
          ],
          [
            {
              sortable: false
            },
            {
              text: 'Дата',
              value: 'date',
              sortable: false,
              caption: '"Да": Если % прослушки оператора ниже целевого  процента прослушки по проекту или КЛН оператора ниже 90%.',
            },
            {
              text: 'Оператор',
              value: 'agent',
              sortable: false,
            },
            {
              text: 'Очередь',
              value: 'queue',
              sortable: false,
            },
            {
              text: 'Абонент',
              value: 'client',
              sortable: false,
            },
            {
              text: 'Анализ ИИ',
              //  value: 'client',
              value: 'analysis_ai',
              sortable: false,
            },
            {
              text: 'ОТЭ',
              //  value: 'client',
              value: 'analysis_ai_grade',
              sortable: false,
              caption: 'Оценка Телефонного Этикета'
            },
            {
              text: 'Маркеры абонентов',
              value: 'voicer[markers][1][dictionary_name]',
              sortable: false,
            },
            {
              text: 'Маркеры операторов',
              value: 'voicer[markers][0][dictionary_name]',
              sortable: false,
            },
            {
              text: 'По скрипту',
              value: 'script_compliance',
              sortable: false,
            },
            {
              text: '',
              value: 'emotions',
              sortable: false,
            },
            {
              text: 'Клн',
              value: 'kln',
              sortable: false,
              align: 'center',
            },
            {
              text: 'Проверен',
              value: 'meta',
              sortable: false,
              align: 'center',
            },
            {
              text: 'Просмотр',
              value: 'actions',
              sortable: false
            },
          ],
        ],
        items: [],
        projectInfo: {},
        projectWiretapIsNeeded: false,
      },
      perPage: 25,
      perPages: [5, 10, 20, 25, 50, 100],
      page: 1,
      paginationTotalVisible: 7,
      orderBy: 'date',
      orderDesc: true,
      dialogView: false,
      dialogViewUid: null,

      infoDialog: false,

      statistic: {},
      statisticRoutes: null, // доступные пользователю показатели статистики, грузятся один раз
      statisticRequestId: 0,
      statisticPending: [], // показатели, по которым ещё идёт запрос — у их блоков рисуется скелетон
      STATISTIC_SKELETON: 'list-item@5',

      statisticBadges: [],
      emoticons: {
        agent: [],
        client: []
      },
      emoticonMode: 0, // 0 - абонент; 1 - оператор
      statisticsStartExten: null,

      callsFeedModal: false,
      callsLoading: false,
      statisticLoading: false,

      repeatDialsPhoneSearch: '',
      repeatDialsExpanded: false,
    }
  },

  computed: {
    ...mapGetters({
      hasPermission: 'user/hasPermission',
      queuesGetter: 'projects/queues',
      filteredQueues: 'projects/filteredQueues',
      loading: 'shared/getLoading',
      meta: 'shared/meta',
      currentUser: 'user/currentUser',
    }),

    payload() {
      let payload = {
        page: this.page,
        limit: this.perPage,
      }

      for (const key in this.filters) {
        let val = this.filters[key]
        if (Array.isArray(val) && val.length === 0) continue
        if (val) payload[key] = val
      }

      if (this.filters.period) {
        payload.period = [
          moment(this.filters.period.start).format('YYYY-MM-DD HH:mm:ss'),
          moment(this.filters.period.end).format('YYYY-MM-DD HH:mm:ss'),
        ]
      }

      return payload
    },

    wiretappingRateTitle() {
      if (this.report.wiretapping_rate !== '') {
        return 'Целевой показатель количества прослушанных звонков к их общему количеству'
      }

      return 'Целевой показатель количества прослушанных звонков к их общему количеству.\n'
        + 'Если прогнозное количество/количество звонков за месяц:\n'
        + '- до 100 звонков за месяц - 30%\n'
        + '- от 101 до 300 звонков - 15%,\n'
        + '- от 301 до 500 зв. - 10%,\n'
        + '- от 501 до 7500 зв. - 5%,\n'
        + '- от 7501 зв. и более - 3%.\n'
        + '- от 15001 зв. и более - 1.5%';
    },

    callsCountTitle() {
      if (this.report.month === 'previous') {
        return 'Всего звонков'
      }

      return 'Кол-во принятых звонков за 28 дней на текущую дату. / 28 дней * 30.42 (среднее количество дней в месяце)'
    },

    rabbitIconTitle() {
      return 'Оператор заслуживающий доверия т.к. выполнены все следующие условия:\n'
          + 'а) % прослушки за выбранный  месяц более 3%\n'
          + 'б) кол-во прослушанных звонков за выбранный месяц более 3 шт.\n'
          + 'в) у оператора за последний месяц КЛН выше 97%\n'
          + 'г) у оператора за 3 последних месяца (в том числе текущем) КЛН выше 97%'
    },

    integrationCallbacks() {
      const list = this.statistic.integration_callbacks_statistic
      return Array.isArray(list) ? list : []
    },

    repeatDialsFiltered() {
      if (!('repeat_dials_statistic' in this.statistic) || !this.statistic.repeat_dials_statistic?.length) {
        return []
      }
      const list = this.statistic.repeat_dials_statistic
      const raw = (this.repeatDialsPhoneSearch || '').trim()
      if (!raw) return list
      const qLower = raw.toLowerCase()
      const qDigits = raw.replace(/\D/g, '')
      return list.filter((item) => {
        const phone = String(item.client_phone ?? '')
        if (qDigits.length) {
          return phone.replace(/\D/g, '').includes(qDigits)
        }
        return phone.toLowerCase().includes(qLower)
      })
    },

    repeatDialsDisplayed() {
      const all = this.repeatDialsFiltered
      return this.repeatDialsExpanded ? all : all.slice(0, 10)
    },

    repeatDialsCanToggleExpand() {
      return this.repeatDialsFiltered.length > 10
    },
  },

  watch: {
    repeatDialsPhoneSearch() {
      this.repeatDialsExpanded = false
    },

    search() {
      if (this.search.length > 3) this.refreshTable()
      else if (this.search.length === 0) this.refreshTable()
    },

    call(newVal) {
      if (newVal !== null) this.dialogView = true
      else this.dialogView = false
    },

    perPage() {
      this.page = 1
      this.refreshTable()
    },
  },

  methods: {
    ...mapActions({
      loadCalls: 'reports_speech_analysis/loadCalls',
      loadStatisticRoutes: 'reports_speech_analysis/loadStatisticRoutes',
      loadStatisticPart: 'reports_speech_analysis/loadStatisticPart',
      loadCallStatuses: 'reports_speech_analysis/loadCallStatuses',
      resetAllState: 'resetAllState',
    }),

    viewItem(call) {
      call.is_current_viewed = true
      this.dialogViewUid = call.uid
      this.dialogView = true
    },

    pageChange(page) {
      this.page = page
      this.refreshTable()
    },

    refreshTable() {
      this.callsLoading = true

      this.loadCalls(this.payload)
        .then((resp) => {
          this.report.payload = this.payload
          this.report.payload.phrase = this.searchPhrase
          this.report.payload.phraseOwner = this.phraseOwner
          this.report.items = resp
          this.callsLoading = false
        })
    },

    changeExpand(curItem) {
      const itemIndex = this.expanded.findIndex(item => item.uid === curItem.uid)

      if (itemIndex === -1) {
        this.expanded.push(curItem)
        return
      }

      this.expanded.splice(itemIndex, 1)
    },

    getEmoColor(type) {
      const colors = {
        sad: 'yellow',
        positive: 'green',
        neutral: 'blue',
        angry: 'red',
        other: 'grey',
        'грустный': 'yellow',
        'позитивный': 'green',
        'нейтральный': 'blue',
        'агресивный': 'red',
        'другое': 'grey',
      }

      return colors[type.toLowerCase()]
    },

    getEmoIcon(type, who) {
      const icons = {
        sad: 'mdi-emoticon-sad',
        positive: 'mdi-emoticon-excited',
        neutral: 'mdi-emoticon-neutral',
        angry: 'mdi-emoticon-angry',
        other: 'mdi-face-man',
        'грустный': 'mdi-emoticon-sad',
        'позитивный': 'mdi-emoticon-excited',
        'нейтральный': 'mdi-emoticon-neutral',
        'агресивный': 'mdi-emoticon-angry',
        'другое': 'mdi-face-man',
      }
      let icon = icons[type.toLowerCase()]
      if (who && who === 'agent') icon += '-outline'
      else if (this.emoticonMode === 1) icon += '-outline'
      return icon
    },

    async loadReport(excel = false) {
      if (!this.$refs.form.validate()) return false
      this.callsLoading = true
      this.statisticLoading = true

      this.page = 1
      this.statistic = {}
      this.report.items = []

      const payload = {...this.payload}
      if (excel) payload.excel = true

      this.loadCalls(payload).then((response) => {
        if (excel) {
          this.callsLoading = false
          this.statisticLoading = false
          return
        }

        this.report.items = response

        if (this.report.items.length > 0) this.expansion = 2

        this.callsLoading = false
      })

      if (excel) return

      this.emoticons = {
        agent: [],
        client: []
      }
      this.statisticBadges = []

      this.repeatDialsPhoneSearch = ''
      this.repeatDialsExpanded = false
      this.loadStatistic(this.payload)
    },

    isStatisticPending(name) {
      return this.statisticPending.includes(name)
    },

    // Каждый показатель статистики грузится отдельным запросом и рисуется по мере прихода
    async loadStatistic(payload) {
      const requestId = ++this.statisticRequestId
      this.statisticPending = []

      try {
        if (!this.statisticRoutes) this.statisticRoutes = await this.loadStatisticRoutes()
      } catch (e) {
        if (requestId === this.statisticRequestId) this.statisticLoading = false
        return
      }

      if (requestId !== this.statisticRequestId) return
      this.statisticPending = [...this.statisticRoutes]

      await Promise.allSettled(this.statisticRoutes.map(name =>
        this.loadStatisticPart({name, payload}).then((data) => {
          // Ответы по устаревшим фильтрам игнорируем
          if (requestId !== this.statisticRequestId) return
          this.statistic = {...this.statistic, ...data}
        }).finally(() => {
          if (requestId !== this.statisticRequestId) return
          this.statisticPending = this.statisticPending.filter(pending => pending !== name)
        })
      ))

      if (requestId === this.statisticRequestId) this.statisticLoading = false
    },

    rowColor(item) {
      let cssClass = ''
      if (item.color === '#2196F3') cssClass = 'transfered-call'
      if (item.is_current_viewed) cssClass = 'viewed-call'

      return cssClass
    },

    formatDate(date) {
      return moment(date).format('YYYY-MM-DD')
    },

    loadByGetParams() {
      if (this.$route.query['period[start]'] && this.$route.query['period[end]']) {
        this.filters.period = {
          start: new Date(this.$route.query['period[start]']),
          end: new Date(this.$route.query['period[end]']),
        }
      }

      if (this.$route.query.user_id) {
        this.filters.users = [parseInt(this.$route.query.user_id)]
      }

      if (this.$route.query.project_id) {
        this.filters.projects = [Number(this.$route.query.project_id)]
        this.loadReport()
      }

      if (this.$route.query.emotion_client) {
        this.filters.emotion_client = this.$route.query.emotion_client
        this.tableMode = 1
      }
      if (this.$route.query.emotion_agent) {
        this.filters.emotion_agent = this.$route.query.emotion_agent
        this.tableMode = 1
      }

      if (this.$route.query.project) {
        this.filters.projects = [Number(this.$route.query.project)]
        this.loadReport()
      }
    },

    showFeed() {
      if (!this.$refs.form.validate()) return false
      this.callsFeedModal = true
    },

    callUrl(uid) {
      return `${process.env.VUE_APP_API_DOMAIN}${this.$router.resolve({
        name: 'SpeechAnalysisCall',
        params: {
          uid,
        }
      }).href}`
    },

    getEmoteUrl(emote, who) {
      const clearFilters = {}
      const emotesEn = {
        'грустный': 'sad',
        'позитивный': 'positive',
        'нейтральный': 'neutral',
        'агресивный': 'angry',
        'другое': 'other',
      }

      const emoteEn = emotesEn[emote.toLowerCase()] || emote
      if (who === 'client') {
        clearFilters.emotion_client = emoteEn
      } else {
        clearFilters.emotion_agent = emoteEn
      }

      for (const key in this.filters) {
        if (['period', 'duration', 'hold_duration', 'projects'].includes(key)) continue
        if (Array.isArray(this.filters[key]) && this.filters[key].length === 0) continue
        if (!this.filters[key]) continue
        clearFilters[key] = this.filters[key]
      }

      if (this.filters.projects[0]) {
        clearFilters.project = this.filters.projects[0]
      }

      let url =  `${process.env.VUE_APP_API_DOMAIN}${this.$router.resolve({
        name: 'speech-analysis.report',
        query: {
          ...clearFilters,
        }
      }).href}`

      url += `&period[start]=${moment(this.filters.period.start).format('YYYY-MM-DD HH:mm:ss')}`
      url += `&period[end]=${moment(this.filters.period.end).format('YYYY-MM-DD HH:mm:ss')}`

      return url
    },

    filterByEmotion(emotion, who) {
      this.$set(this.filters, who === 'client' ? 'emotion_client' : 'emotion_agent', emotion)
      this.tableMode = 1
      this.loadReport()
    },

    loadReportClean(excel) {
      if (!excel) {
        this.$set(this.filters, 'emotion_client', null)
        this.$set(this.filters, 'emotion_agent', null)
      }
      this.loadReport(excel)
    },
  },

  async mounted() {
  },

  beforeDestroy() {
    this.resetAllState()
  },
}


</script>

<style lang="scss">
.theme--light {
  .viewed-call {
    background-color: #c8e6c8 !important;
  }
}

.theme--dark {
  .viewed-call {
    background-color: #546E7A !important;
  }
}

.transfered-call {
  background-color: #2196F3 !important;
}

.expansion-zero-padding > div {
  padding: 0 !important;
}
</style>
